import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../lib/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const { exchangeGoogleSession } = useAuth();
  const nav = useNavigate();
  const hasProcessed = React.useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) { nav("/login"); return; }
    const session_id = match[1];
    (async () => {
      try {
        await exchangeGoogleSession(session_id);
        window.history.replaceState({}, "", "/");
        nav("/");
      } catch (e) {
        console.error("oauth exchange failed", e);
        nav("/login");
      }
    })();
  }, [exchangeGoogleSession, nav]);

  return (
    <div className="min-h-[60vh] flex items-center justify-center">
      <div className="text-[#D4FF00] font-display text-2xl uppercase animate-pulse">Signing you in…</div>
    </div>
  );
}
